module.exports = __webpack_public_path__ + "img/carryOver2.9f40ca7f.png";